import React, { useState } from 'react';
import Barcode from 'react-barcode';
import { get } from 'lodash';
import { any, bool, string, object } from 'prop-types';
import { Button, Modal, FlexContainer } from '../../common';

const FormPOS = ({ data, condition, title, buttonType }) => {
    const [visiblePOS, setVisiblePOS] = useState(false);
    const status = get(data, 'assignInfo.status.code', '0');
    const eanOrder = get(data, 'assignInfo.eanOrder', '0');
    if (!condition && !['4', '9'].includes(status)) return null;
    return (
        <>
            <Button
                bold={false}
                {...buttonType}
                text={title}
                className='sisaButton'
                onClick={() => setVisiblePOS(true)}
            />
            <Modal
                title='Formulario POS'
                visible={visiblePOS}
                onClose={() => setVisiblePOS(false)}
                width={400}
            >
                <FlexContainer direction='column' flex='1' center>
                    <Barcode
                        value={eanOrder}
                        width={2}
                        height={105}
                        fontSize={30}
                        marginTop={10}
                        marginBottom={20}
                    />
                </FlexContainer>
                <Button
                    text='Cerrar'
                    fitContent
                    style={{ alignSelf: 'flex-end' }}
                    onClick={() => setVisiblePOS(false)}
                />
            </Modal>
        </>
    );
};

FormPOS.propTypes = {
    data: any,
    condition: bool,
    title: string,
    buttonType: object
};

FormPOS.defaultProps = {
    title: 'Formulario POS',
    buttonType: { link: true }
};

export default FormPOS;
